<div class="audit-history">
    <fa-icon [icon]="faIconName.faHistory" class="history-icon"></fa-icon>
</div>
